import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoticeFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 18C7.125 18 4.5 16.5 3.0625 14C1.625 11.5312 1.625 8.5 3.0625 6C4.5 3.53125 7.125 2 10 2C12.8438 2 15.4688 3.53125 16.9062 6C18.3438 8.5 18.3438 11.5312 16.9062 14C15.4688 16.5 12.8438 18 10 18ZM10 6C9.5625 6 9.25 6.34375 9.25 6.75V10.25C9.25 10.6875 9.5625 11 10 11C10.4063 11 10.75 10.6875 10.75 10.25L10.75 6.75C10.75 6.34375 10.4062 6 10 6ZM9 13C9 13.5625 9.4375 14 10 14C10.5313 14 11 13.5625 11 13C11 12.4687 10.5313 12 10 12C9.4375 12 9 12.4687 9 13Z"
	})
});
const ForwardRef = forwardRef(SvgNoticeFilled);
export default ForwardRef;
